import { useCallback, useEffect, useState } from 'react';

import { useAttachmentSignedUrl } from 'hooks/useAttachmentSignedUrl';

export function useClickAttachment(attachmentId: string, attachableModel?: string) {
  const [attachmentToFetchId, setAttachmentToFetchId] = useState<string>('');

  const { data: attachmentData, isStale, refetch } = useAttachmentSignedUrl(attachmentToFetchId, attachableModel);

  const openAttachment = useCallback(() => {
    if (isStale) {
      refetch();
    } else if (attachmentData?.url) {
      window.open(attachmentData?.url, '_blank');
    } else {
      setAttachmentToFetchId(attachmentId);
    }
  }, [attachmentId, isStale, attachmentData?.url, refetch]);

  useEffect(() => {
    if (attachmentData?.url) {
      window.open(attachmentData?.url, '_blank');
    }
  }, [attachmentData?.url]);

  return openAttachment;
}
